export default __webpack_public_path__ + "media/images/project-image-cd9a710d1e4753fc61208363d371c3e7.png";